"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskReviewPanelApp = void 0;
var React = require("react");
var App_1 = require("../../App");
var generic_1 = require("../generic");
var buttons_1 = require("../buttons");
var mobx_react_1 = require("mobx-react");
var RiskReviewPanelApp = (function (_super) {
    __extends(RiskReviewPanelApp, _super);
    function RiskReviewPanelApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskReviewPanelApp.prototype.onClickHandler = function (event) {
        App_1.store.riskPage.riskReview.updateRiskReview().then(function () {
            notification(gettext("Risk review updated."));
            App_1.store.riskPage.riskReview.fetchRiskReview();
        });
    };
    RiskReviewPanelApp.prototype.render = function () {
        var review = App_1.store.riskPage.riskReview.review;
        var hasPermission = App_1.store.riskPage.riskReview.hasPermission;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("table", { className: "w-100" },
                    React.createElement("tr", { className: "w-100" },
                        React.createElement("td", null, review ?
                            gettext('Reviewed by {reviewer_name} on {review_date}')
                                .replace('{reviewer_name}', review.reviewed_by_full_name)
                                .replace('{review_date}', review.modified) :
                            gettext("Not reviewed")),
                        hasPermission &&
                            React.createElement("td", { className: "RiskReviewPanelApp__button text-right" },
                                React.createElement(buttons_1.ActionButton, { id: "update_review", className: "btn-sm", onClick: this.onClickHandler },
                                    React.createElement(generic_1.Icon, { name: generic_1.Icons.check_circle }),
                                    gettext("Update review"))))))));
    };
    RiskReviewPanelApp = __decorate([
        mobx_react_1.observer
    ], RiskReviewPanelApp);
    return RiskReviewPanelApp;
}(React.Component));
exports.RiskReviewPanelApp = RiskReviewPanelApp;
